<template>
  <ModalConfirmation labelYes="OK"
                     labelNo="Cancel"
                     minWidthNoButton="80px"
                     minWidthYesButton="80px"
                     v-bind="modalAttrs"
                     :name="modalName"
                     :text="text"
                     @before-open="beforeModalOpen"
                     @yes="deleteTenantTeam"
                     @no="cancel" />
</template>

<script>
  import ApiTenantTeam from '@js/api/tenant-team'
  import ModalConfirmation from '@modals/modal-confirmation'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'ModalDeleteTenantTeam',
    components: {
      ModalConfirmation,
    },
    data: function () {
      return {
        modalAttrs: {
          height: '222px',
          width: '400px',
        },
        modalName: MODAL_WINDOW_NAMES.DELETE_TENANT_TEAM_PRIMARY,
        tenantTeam: null,
      };
    },
    computed: {
      text: function () {
        const tenantTeamName = this.tenantTeam != null ? this.tenantTeam.name : 'team';
        return `Are you sure you want to delete ${tenantTeamName}?`
      },
    },
    methods: {
      beforeModalOpen: function (e) {
        this.tenantTeam = e.params ? (e.params.tenantTeam ? e.params.tenantTeam : null) : null;
      },
      cancel: function () {
        this.close();
      },
      clear: function () {
        this.tenantTeam = null;
      },
      close: function () {
        this.clear();
        this.$modal.hide(this.modalName);
      },
      deleteTenantTeam: async function () {
        try {
          const api = await new ApiTenantTeam(this.tenantTeam.id);
          const res = await api.delete();
          await this.$emit('deleted-tenant-team');
          await this.$store.commit(
            'notification/setMessage', `Deleted ${this.tenantTeam.name}`);
          await this.close();
          await this.$router.push({ name: 'teamup-select' });
        } catch (error) {
          this.$store.commit('notification/setWarning', 'Failed to delete team');
          console.error(error);
        }
      }
    },
  };
</script>
